import React from "react";
import { Tabs, Collapse, Row, Col, Button, Empty } from "antd";
import { AdvancedSearchProvidersTabsProps } from "./Types";
import moment from "moment";
import { Appointment, showModalForSchedule } from "../../../store/apointment";
import { AdvancedSearchProvider } from "../../../store/advanced-search";
import { useDispatch } from "react-redux";
import { Trans } from "@lingui/macro";

export const AdvancedSearchProvidersTabs: React.FC<AdvancedSearchProvidersTabsProps> = (
  props
) => {
  const { advancedSearchState } = props;
  const dispatch = useDispatch();

  const onTimeSelected = (value: string) => {
    const [providerId, strDate, strTime] = value.split("@");
    const provider = advancedSearchState.providers.find(
      (x) => x.ProviderID === providerId
    ) as AdvancedSearchProvider;
    const date = moment(strDate, "YYYY-MM-DD");
    const startTime = moment(strTime, "HH:mm");
    const endTime = moment(strTime, "HH:mm").add(
      provider.AppointmentIntervalMinutes,
      "minutes"
    );

    const appointment: Appointment = {
      agendaId: provider.AgendaID,
      agendaName: provider.AgendaName,
      date,
      endTime,
      locationId: provider.LocationID,
      providerId,
      startTime,
      notes: "",
      allowReSchedule: true,
      isTelehealth: true,
    };

    dispatch(showModalForSchedule(appointment));
  };

  return (
    <Row
      type="flex"
      justify="center"
      style={{ marginTop: "10px", width: "100%" }}
    >
      {advancedSearchState.providers.length <= 0 ? (
        <Empty
          description={
            <Trans render="span" id="Common.NoData">
              There's no data
            </Trans>
          }
        />
      ) : (
        <Tabs style={{ width: "100%" }}>
          {advancedSearchState.providers.map((provider) => (
            <Tabs.TabPane tab={provider.FullName} key={provider.UID}>
              <Collapse>
                {provider.TimeSlots.map((timeslot, index) => (
                  <Collapse.Panel
                    header={timeslot.Date.format("dddd LL")}
                    key={index}
                  >
                    <Row type="flex" gutter={[4, 8]}>
                      {timeslot.Hours.map((time, index) => (
                        <Col key={index}>
                          <Button
                            onClick={(e) =>
                              onTimeSelected(
                                `${provider.ProviderID}@${timeslot.Date.format(
                                  "YYYY-MM-DD"
                                )}@${time.format("HH:mm")}`
                              )
                            }
                          >
                            {time.format("hh:mm a")}
                          </Button>
                        </Col>
                      ))}
                    </Row>
                  </Collapse.Panel>
                ))}
              </Collapse>
            </Tabs.TabPane>
          ))}
        </Tabs>
      )}
    </Row>
  );
};
